export function FaqPage() {
  return (
    <section className="page band" id="faq" data-testid="dp-page-faq">
      <div className="wrap">
        <div className="head">
          <div className="eyebrow">FAQ</div>
          <h2>Clear expectations from the first conversation.</h2>
        </div>
        <div className="faq">
          <details>
            <summary>Who is Zephix for?</summary>
            <p>
              Zephix is for anyone responsible for moving important work across people, teams, or
              departments—whether you work in operations, marketing, procurement, finance, product,
              IT, or another function. We are starting with structured, cross-functional initiatives
              where ownership, risk, approvals, and decisions need to stay visible.
            </p>
          </details>
          <details>
            <summary>Can I access a free trial?</summary>
            <p>
              Not yet. Zephix is currently in a design-partner discovery phase. We are conducting
              conversations first, followed by moderated product sessions with qualified partners.
            </p>
          </details>
          <details>
            <summary>How is this different from Asana, monday.com, or Jira?</summary>
            <p>
              Asana, monday.com, and Jira are broad work platforms that teams often configure around
              their own processes. Zephix is building a connected work-management system that brings
              projects, governance, risk, resources, and portfolio visibility together. We begin with
              practical, preconfigured workflows for structured cross-functional work, so teams can
              get control quickly without enterprise PPM overhead.
            </p>
          </details>
          <details>
            <summary>Will AI make decisions or change my project automatically?</summary>
            <p>
              No. Our direction is advisory: AI should help explain, summarize, and flag patterns
              while people remain accountable for decisions.
            </p>
          </details>
          <details>
            <summary>What happens after I apply?</summary>
            <p>
              If your organization is a fit, we will contact you to schedule a 30-minute discovery
              conversation. No payment or trial account is required to have that conversation.
            </p>
          </details>
        </div>
      </div>
    </section>
  );
}
